export default __webpack_public_path__ + "svg/logo-b-new.svg?7c9a08bc";